import { Users } from "lucide-react";

export const USERS_PATH = "/settings/users";

export const USERS_TABLE_CONSTANTS = {
  tableName: "users_table",
  queryKey: "users",
  className: "User",
  exportTableName: "UsersTable",
  header: "Users",
  headerIcon: Users,
};
